import { fetcher } from '@commenda/utils';
import { SetSettingPayload, Setting } from './types';

export async function updateSetting({
  key,
  value,
  entities,
}: SetSettingPayload): Promise<{
  success: boolean;
  data?: Setting;
  error?: string;
}> {
  try {
    const response = await fetcher('settings', {
      method: 'POST',
      body: { key, value, entities },
    });

    const data = await response.json();

    if (!response.ok) {
      return {
        success: false,
        error: data.message || 'Failed to update setting',
      };
    }

    return {
      success: true,
      data,
    };
  } catch (error) {
    return {
      success: false,
      error:
        error instanceof Error ? error.message : 'An unexpected error occurred',
    };
  }
}
